import axios from 'axios';
import jwt from 'jwt-decode'
import { UserPreference } from '../features/trading-system/users/UserAccessories';
import { PermissionObjectIds } from '../models/enums/PermissionObjects';
import { UserActions } from '../models/enums/UserActions';
import { Permission } from '../models/permissions/Permission';

export interface authData {
    token: string,
    name: string,
    userId: number,
    userName: string,
    region: string,
    defaultPage: string,
    permission: Array<Permission>
}

export interface tokenData {
    nameid: string,
    unique_name: string,
    given_name: string,
    family_name: string,
    groupsid?: number,
    role: string,
    ho_token: string,
    nbf: number,
    exp: number,
    iat: number
}

export function setAuthData(data: authData, rememberMe: boolean = false) {
    sessionStorage.setItem("authData", JSON.stringify(data));
    sessionStorage.setItem("defaultPage", data.defaultPage);
    sessionStorage.setItem("authTime", (new Date()).toString());

    if (rememberMe)
        localStorage.setItem("userName", data.userName);
    else
        localStorage.removeItem("userName");
}

export function getAuthData(): authData | null {
    let authString = sessionStorage.getItem("authData") ?? null;

    if (authString){
        return JSON.parse(authString) as authData;
    }
    return null;
}

export function logout(){
    sessionStorage.removeItem("authData");
}

export function getToken(): string | null {
    return getAuthData()?.token ?? null;
}

export function isLoggedIn(): boolean {
    let data = getAuthData();
    if (data){
        return true;
    }
    return false;
}

export function getDefaultPage()
{
    let data = getAuthData();
    if (data != null)
    {
        switch(data.defaultPage)
        {
            case "QT":
                return "quotation";
            case "PO":
                return "purchaseorder";
            case "IV":
                return "invoice";
            case "PL":
                return "packinglist";
            default:
                return "quotation";
        }
    }   
    else
        return "";
}

export function getDefaultRegion()
{
    let data = getAuthData();
    if (data != null)
        return data.region;
    else
        return "";    
}

export function getUserPreferences() : UserPreference | null
{
    let userPreferencesString = sessionStorage.getItem("userPreferences") ?? null;

    if (userPreferencesString)
        return JSON.parse(userPreferencesString) as UserPreference;

    let data = getAuthData();
    if (data != null)
    {
        sessionStorage.setItem("userPreferences", JSON.stringify({
            staffId: data.userId,
            staffName: data.name,
            userName: data.userName,
            defaultRegion: data.region,
            defaultPage: data.defaultPage,
            permission: data.permission            
        }))
        return {
            staffId: data.userId,
            staffName: data.name,
            userName: data.userName,
            defaultRegion: data.region,
            defaultPage: data.defaultPage,
            permission: data.permission            
        };
    }
    else
        return null;    
}

export function setUserPreferences(name: string, defaultPage: string, region: string)
{
    let userPreferencesString = sessionStorage.getItem("userPreferences") ?? null;
    if (userPreferencesString)
    {
        let currentPreferences = JSON.parse(userPreferencesString) as UserPreference;
        currentPreferences.staffName = name;
        currentPreferences.defaultPage = defaultPage;
        currentPreferences.defaultRegion = region;
        sessionStorage.setItem("userPreferences", JSON.stringify(currentPreferences));
    }


}

export function hasPermission(permissionObject: PermissionObjectIds, userAction: UserActions)
{
    let data = getAuthData();
    if (data != null)
    {
        for (let item of data.permission) {
            if (permissionObject == item.ObjectId)
            {
                if (item.Action===null)
                    return false;

                if (item.Action.toString().split('|').indexOf(userAction.toString())>-1)
                    return true;
            }
        }
        return false;   
    }
    else
    {
        return false;
    }
}

export function decodeToken(): tokenData | null {
    let data = getAuthData();
    if (data){
        let token = data.token;
        if (token){
            let tokenDataReturn = jwt<tokenData>(token);
            return tokenDataReturn;
        }
    }

    return null;
}

export function renewToken() {
    let currentTime = new Date()
    let lastAuthTime = new Date(sessionStorage.getItem("authTime") ?? (new Date()).toString());

    //Minutes passed since token renewed
    let timePassed = (currentTime.getTime() - lastAuthTime.getTime()) / 60000;

    //Renew token after 45 minutes
    if (timePassed >= 45)
    {
        axios.post<authData>('Api/V1/Auth/RefreshToken', {}, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
            .then(function (response) {
                setAuthData(response.data, false);
            })
            .catch(function (error) {
                console.log(error);
            });        
    }
}